import { parseRangeModeFilterValue } from '@/components/data-table/filters-v2/utils/range-mode-filter-value';
import { RangeMode } from '@/types/filters';

type FilterValue = string | string[] | undefined;

export interface RangeBounds {
  minInclusive?: number;
  maxInclusive?: number;
  minExclusive?: number;
  maxExclusive?: number;
}

/**
 * Converts a persisted range filter (`"mode:amount[:strict]"`) into API bounds.
 *
 * `multiplier` converts the UI amount to the API unit (for example, hours to
 * minutes); use `1` when both layers use the same unit. More/Less use inclusive
 * bounds by default and exclusive bounds with the `:strict` suffix. Equal always
 * produces matching inclusive minimum and maximum bounds.
 *
 * Returns `null` for an absent or malformed filter value.
 */
export function readRangeBounds({
  value,
  multiplier,
}: {
  value: FilterValue;
  multiplier: number;
}): RangeBounds | null {
  const rawValue = Array.isArray(value) ? value[0] : value;
  const parsed = rawValue ? parseRangeModeFilterValue(rawValue) : null;
  if (!parsed || !parsed.amount) return null;

  const amount = Number(parsed.amount) * multiplier;
  if (parsed.mode === RangeMode.Equal) return { minInclusive: amount, maxInclusive: amount };
  if (parsed.mode === RangeMode.More) {
    return parsed.isInclusive ? { minInclusive: amount } : { minExclusive: amount };
  }
  if (parsed.mode === RangeMode.Less) {
    return parsed.isInclusive ? { maxInclusive: amount } : { maxExclusive: amount };
  }
  return null;
}
